<template>
  <div style="width: 100%;overflow-x: hidden">
    <div class="home" ref="home">
      <div ref="main" class="intro">
        <div class="introduction">
          <p class="content">
            DeepSEAI: Deep Structural Engineering with AI <br>
            致力于人工智能与结构工程的交叉研究与应用 <br>
            探索工程结构的高效分析与设计 <br>
            期待成为您的得力助手
          </p>
        </div>
        <div class="try-sna-btn" @click="$router.push({name: 'feature'})">
          探索DeepSEAI &nbsp; <i class="el-icon el-icon-top-right"></i>
        </div>
      </div>
      <div ref="firstModel" class="intro">
        <div class="introduction" style="text-align: left">
          <p class="content">
            工程结构非线性响应智能计算
          </p>
          <div class="feature-intro">
            <div class="w66">
              <img class="feature-intro-img" :src="require('@/assets/home-compute.png')" alt="">
            </div><div class="w33">
              <h6>
                通过数据驱动的方式实现工程结构与材料的非线性全过程力学响应高效计算。目前已开放用户自定义训练模块，基于DeepSNA实现个人智能计算模型的构建与应用；我们还提供了钢板剪力墙结构的demo模块，可供您进行探索尝试，熟悉我们的系统。
              </h6>
              <div class="try-sna-btn" @click="openBroTab('https://www.sciencedirect.com/science/article/pii/S0926580522001285')">
                了解更多 &nbsp; <i class="el-icon el-icon-top-right"></i>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div ref="secondModel" class="intro">
        <div class="introduction"  style="text-align: left">
          <p class="content">
            复杂建筑平面的结构拓扑智能设计
          </p>
          <div class="feature-intro">
            <div class="w66">
              <img class="feature-intro-img" :src="require('@/assets/Deepsai-智能设计.svg')" alt="">
            </div><div class="w33">
            <h6>
              基于深度学习技术，实现从建筑平面布置到结构梁柱方案的自动生成；此外，开放了面向框架结构的智能高效优化模型，输入结构布置方案后可根据预设的工程指标进行所有构件截面尺寸优化，提供合理的结构初步设计方案。
            </h6>
            <div class="try-sna-btn" @click="openBroTab('https://mp.weixin.qq.com/s/9N3vSbzPAj_YaYFvs5jauw')">
              了解更多 &nbsp; <i class="el-icon el-icon-top-right"></i>
            </div>
          </div>
          </div>
        </div>

      </div>
      <div ref="thirdModel" class="intro">
        <div class="introduction"  style="text-align: left">
          <p class="content">
            设计公式智能生成模型EqDisce
          </p>
          <div class="feature-intro">
            <div class="w66">
              <img class="feature-intro-img" :src="require('@/assets/EqDisce.png')" alt="">
            </div><div class="w33">
            <h6>
              EqDisce能够从试验或分析数据中自动生成量纲正确、可解释的工程设计公式，且可引入工程先验知识对数据进行分段，提升设计公式精度与物理含义。期望加速新材料、新结构从试验研究到工程应用的落地转化进程。
            </h6>
            <div class="try-sna-btn" @click="openBroTab('https://mp.weixin.qq.com/s/qTrWYhsJB1a3upLX0Mazgw')">
              了解更多 &nbsp; <i class="el-icon el-icon-top-right"></i>
            </div>
          </div>
          </div>
        </div>

      </div>

    </div>
    <div class="left-nav">
      <div class="nav-item" :class="activeTab === '1' ? 'isActive' : ''" @click="activeTab = '1';$refs.main.scrollIntoView({behavior: 'smooth', block: 'start'})"></div>
      <div class="nav-item" :class="activeTab === '2' ? 'isActive' : ''" @click="activeTab = '2';$refs.firstModel.scrollIntoView({behavior: 'smooth', block: 'start'})"></div>
      <div class="nav-item" :class="activeTab === '3' ? 'isActive' : ''" @click="activeTab = '3';$refs.secondModel.scrollIntoView({behavior: 'smooth', block: 'start'})"></div>
      <div class="nav-item" :class="activeTab === '4' ? 'isActive' : ''" @click="activeTab = '4';$refs.thirdModel.scrollIntoView({behavior: 'smooth', block: 'start'})"></div>
    </div>
  </div>


</template>

<script>
import inTitle from '../components/in-title'
import throttle from 'lodash/throttle';

export default {
  name: "home",
  components: {
    inTitle
  },
  data() {
    return {
      activeTab: '1'
    }
  },
  methods: {
    /**
     * 打开第三方页面
     * @param url
     */
    openBroTab(url) {
      window.open(url)
    }
  },
  mounted() {
    // 设置右方小白点位置
    const home = this.$refs.home; // 获取滚动容器
    const intros = document.getElementsByClassName('intro'); // 获取所有滚动项
    // 函数节流
    const scrollHandler = throttle(() => {
      const scrollTop = home.scrollTop;
      const introHeight = intros[0].offsetHeight;
      const index = Math.floor(scrollTop / introHeight + 0.5);
      this.activeTab = (index + 1).toString();
    }, 200);
    home.addEventListener('scroll', scrollHandler); // 监听滚动事件
  }
};
</script>

<style lang="less">
.home {
  color: white;
  height: 82vh;
  width: 102%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;


  .intro {
    height: 82vh;
    scroll-snap-align: start;

  }

  .introduction {
    font-size: 41px;
    padding-top: 12vh;
    margin: 0 auto;
    width: 100%;
    text-align: left;
    .feature-intro{
      font-size: 0;
      padding-top: 5vh;
      vertical-align: top;
      .w66,.w33{
        display: inline-block;
      }
      .try-sna-btn{
        margin-left: 0;
      }
      .w66{
        float: left;
        width: 60%;
        .feature-intro-img{
          margin: 1vh auto;
          width: 88%;
        }
      }
      .w33{
        float: right;
        width: 40%;
        h6{
          width: 90%;
          font-size: 26px;
          text-align: left;
        }
        &::after {
          content: '';
          display: block;
          height: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 1px; /* 伪元素无需宽度，但为避免浮动等问题，可以添加一个极小宽度 */
        }
      }

    }
  }

  img.inner-img {
    display: inline-block;
    width: 425px;
    margin-right: 25px;
  }

  p.content {
    text-align: left;
    padding: 0;
    display: inline-block;
    //text-indent: 2em;
    font-size: 44px;
    font-weight: 600;
  }

  .try-sna-btn {
    float: left;
    margin: 50px 0 0 5px;
    cursor: pointer;
    border: 1px #ffffff solid;
    font-size: 24px;

    &:hover {
      color: #ffbb00;
    }
  }
}

.left-nav{
  opacity: 0.6;
  position: fixed;
  right: 5vw;
  top: 45vh;
  padding: 5px;
  border-radius: 15px;
  background-color: #8c939d;
  &:hover{
    opacity: 0.9;
  }
  .nav-item{
    cursor: pointer;
    margin: 10px 5px;
    width: 8px;
    height: 8px;
    background-color: #ccc;
    border-radius: 50%;
    &:hover{
      background-color: #ffffff;
    }
    &.isActive{
      background-color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue